import { PENDING_TO_RETURN, PENDING_TO_RETURN_SUCCESSFUL, PENDING_TO_RETURN_FAILED } from './actionTypes';

const initialState = {
    pendingToreturnTaskError: null, pendingToreturnTaskMessage: null, pendingToreturnTaskLoading: false
}

const pendingToReturnTask = (state = initialState, action) => {
    switch (action.type) {
        case PENDING_TO_RETURN:
            state = {
                ...state,
                pendingToreturnTaskLoading: true,
                pendingToreturnTaskError: null
            }
            break;
        case PENDING_TO_RETURN_SUCCESSFUL:
            state = {
                ...state,
                pendingToreturnTaskLoading: false,
                pendingToreturnTaskMessage: action.payload,
                pendingToreturnTaskError: null
            }
            break;
        case PENDING_TO_RETURN_FAILED:
            state = {
                ...state,
                pendingToreturnTaskMessage: null,
                pendingToreturnTaskLoading: false,
                pendingToreturnTaskError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default pendingToReturnTask;